import { render, staticRenderFns } from "./addFlow.vue?vue&type=template&id=44e541ee&scoped=true"
import script from "./addFlow.vue?vue&type=script&lang=js"
export * from "./addFlow.vue?vue&type=script&lang=js"
import style0 from "./addFlow.vue?vue&type=style&index=0&id=44e541ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e541ee",
  null
  
)

export default component.exports